import { createContext as o, useContext as e } from "react";
const r = o(null), n = () => {
  const t = e(r);
  if (!t)
    throw new Error("useToast must be used within a ToastProvider");
  return t;
};
export {
  r as ToastContext,
  n as useToast
};
